import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "px-6 py-10 sm:px-10 lg:col-span-2 xl:p-12"
}
const _hoisted_2 = {
  key: 1,
  class: "px-6 py-10 sm:px-10 lg:col-span-1 xl:p-12"
}
const _hoisted_3 = { class: "grid grid-cols-1 mt-6 gap-y-6" }
const _hoisted_4 = { class: "col-span-2" }
const _hoisted_5 = { class: "mt-1" }
const _hoisted_6 = { class: "col-span-2" }
const _hoisted_7 = { class: "mt-1" }
const _hoisted_8 = { class: "col-span-2" }
const _hoisted_9 = { class: "grid grid-cols-1 mt-4 lg:grid-cols-2 gap-y-4" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = ["id", "value", "onUpdate:modelValue"]
const _hoisted_12 = ["for"]
const _hoisted_13 = { class: "block text-sm font-semibold leading-6 text-gray-900" }
const _hoisted_14 = { class: "sm:col-span-2" }
const _hoisted_15 = { class: "mt-1" }
const _hoisted_16 = { class: "col-span-2" }
const _hoisted_17 = { class: "mx-auto mt-1 text-center" }
const _hoisted_18 = { class: "mt-10 text-center" }

import {computed, Ref, ref} from "vue";
import {client, trackEvent} from '@/shared';
import { VueRecaptcha } from 'vue-recaptcha';
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import {ContactUsRequest} from "@/dtos";
import SaButton from "@/main/components/SaButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactUs',
  props: {
    subjectOptions: {}
  },
  setup(__props: any) {

const props = __props;
const request = ref(new ContactUsRequest());

const responseStatus = ref(null);
const isSubmitting = ref(false);
const submitSuccessful: Ref<Boolean> = ref(false);

const submit = async () => {
    isSubmitting.value = true;
    request.value.gRecaptchaResponse = gRecaptchaResponse.value;
    
    await client.post<any>(request.value)
        .then(_ => {
            // only send subject to GA 
            trackEvent( 'contact_form_submitted', {
                subject: request.value.subject
            }, false, true);

            // send details to cio
            trackEvent( 'contact_form_submitted', request.value, true, false);
            
            submitSuccessful.value = true;
            responseStatus.value = null;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            recaptcha.value?.reset();
        });

    isSubmitting.value = false;
}

const recaptcha = ref<InstanceType<typeof VueRecaptcha> | null>(null);
const gRecaptchaResponse = ref('');

const siteKey = computed(() => {
    return '6Lf2aEMUAAAAAM-OcLydSmjTdZFjbztBs7p7tMHp';
});

const handleError = () => {
    // Do some validation
};

const handleSuccess = (response: string) => {
    gRecaptchaResponse.value = response;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[11] || (_cache[11] = _createElementVNode("h1", { class: "text-3xl font-extrabold tracking-tight text-center text-clay-800 md:text-4xl" }, " Contact StageAgent ", -1)),
    _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "mt-3 text-xl tracking-tight text-center font-display text-clay-950 sm:text-2xl" }, "Get in touch and let us know how we can help.", -1)),
    (submitSuccessful.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[3] || (_cache[3] = [
          _createElementVNode("h3", { class: "text-lg font-medium text-center text-clay-800" }, "Thank you! We'll get in touch with you soon. ", -1)
        ])))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "text-xl font-semibold uppercase text-clay-800" }, "Send us a message", -1)),
          _createElementVNode("form", _hoisted_3, [
            _createVNode(ErrorSummary, {
              "response-status": responseStatus.value,
              class: "mt-2"
            }, null, 8, ["response-status"]),
            _createElementVNode("div", _hoisted_4, [
              _cache[4] || (_cache[4] = _createElementVNode("label", {
                for: "name",
                class: "block text-sm font-medium text-clay-800"
              }, "Name", -1)),
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((request.value.name) = $event)),
                  type: "text",
                  name: "name",
                  id: "name",
                  autocomplete: "given-name",
                  required: "",
                  class: "block w-full px-4 py-3 bg-white border rounded-md shadow-sm text-clay-800 focus:ring-electric-500 focus:border-electric-500 border-warm-gray-300 border-clay-500"
                }, null, 512), [
                  [_vModelText, request.value.name]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[5] || (_cache[5] = _createElementVNode("label", {
                for: "email",
                class: "block text-sm font-medium text-clay-800"
              }, "Email", -1)),
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((request.value.email) = $event)),
                  id: "email",
                  name: "email",
                  type: "email",
                  autocomplete: "email",
                  required: "",
                  class: "block w-full px-4 py-3 bg-white border rounded-md shadow-sm text-clay-800 focus:ring-electric-500 focus:border-electric-500 border-warm-gray-300 border-clay-500"
                }, null, 512), [
                  [_vModelText, request.value.email]
                ])
              ])
            ]),
            _createElementVNode("fieldset", _hoisted_8, [
              _cache[6] || (_cache[6] = _createElementVNode("legend", { class: "block text-sm font-medium text-gray-700" }, " Subject ", -1)),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.subjectOptions, (subject) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                      id: subject,
                      name: "subject",
                      value: subject,
                      "onUpdate:modelValue": ($event: any) => ((request.value.subject) = $event),
                      type: "radio",
                      class: "w-4 h-4 border-clay-500 focus:ring-grape-500 text-grape-600"
                    }, null, 8, _hoisted_11), [
                      [_vModelRadio, request.value.subject]
                    ]),
                    _createElementVNode("label", {
                      for: subject,
                      class: "ml-3"
                    }, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(subject), 1)
                    ], 8, _hoisted_12)
                  ]))
                }), 256))
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex justify-between" }, [
                _createElementVNode("label", {
                  for: "message",
                  class: "block text-sm font-medium text-clay-800"
                }, "Message")
              ], -1)),
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((request.value.message) = $event)),
                  id: "message",
                  name: "message",
                  rows: "4",
                  required: "",
                  class: "block w-full px-4 py-3 bg-white border rounded-md shadow-sm text-clay-800 focus:ring-electric-500 focus:border-electric-500 border-warm-gray-300 border-clay-500",
                  "aria-describedby": "message-max"
                }, "                    ", 512), [
                  [_vModelText, request.value.message]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_unref(VueRecaptcha), {
                  class: "inline-block mx-auto text-center g-recaptcha w-100 captcha-container contact-captcha",
                  ref_key: "recaptcha",
                  ref: recaptcha,
                  sitekey: siteKey.value,
                  "load-recaptcha-script": true,
                  onVerify: handleSuccess,
                  onError: handleError
                }, null, 8, ["sitekey"])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(SaButton, {
                onClick: _withModifiers(submit, ["prevent"]),
                loading: isSubmitting.value,
                variant: "primary"
              }, {
                loading: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createElementVNode("span", { class: "font-semibold" }, "Submitting...", -1)
                ])),
                default: _withCtx(() => [
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "font-semibold" }, "Submit", -1))
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ])
        ]))
  ], 64))
}
}

})